import { call, put, takeLatest } from "redux-saga/effects";
import { getCancelByDateApi, updateToNewBookingApi } from "../../utils/booking/Cancel";
import { UPDATE_TO_NEW_BOOKING_REQUEST, updateToNewBookingFailure, updateToNewBookingSuccess } from "../actions/cancelActions";
import { AxiosResponse } from "axios";

function* getCancelByDateSaga(action: any): any {
    try {
        const { branchid, fromdate, todate } =
            action.payload;

        const response = yield call(
            getCancelByDateApi,
            branchid,
            fromdate,
            todate
        );

        yield put({
            type: "GET_CANCEL_BY_DATE_SUCCESS",
            payload: response.data.data.data,
        });
    } catch (error: any) {
        yield put({
            type: "GET_CANCEL_BY_DATE_FAILURE",
            payload: error.message,
        });
    }
}

function* updateToNewBookingWorker(action: any): any {
    try {
        const response: AxiosResponse<any> = yield call(
            updateToNewBookingApi,
            { bookid: action.payload.bookid, updatedBy: action.payload.updatedBy }
        );
        yield put(updateToNewBookingSuccess(response.data));
    } catch (error: any) {
        const errorMessage =
            error.response?.data?.message || error.message || "Something went wrong";
        yield put(updateToNewBookingFailure(errorMessage));
    }
}

export function* watchGetCancelByDate() {
    yield takeLatest(
        "GET_CANCEL_BY_DATE_REQUEST",
        getCancelByDateSaga
    );
}

export function* watchUpdateToNewBooking() {
    yield takeLatest(UPDATE_TO_NEW_BOOKING_REQUEST, updateToNewBookingWorker);
}